module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', [_c('loader')], 1) : _c('div', [_c('h1', [_vm._v("Requisições")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-2"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.perPage),
      expression: "perPage"
    }],
    staticClass: "input-sm",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.perPage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.getList]
    }
  }, [_c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 10
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 15
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('b-form-input', {
    staticClass: "input-sm",
    attrs: {
      "placeholder": "Digite e pressione Enter"
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  })], 1)]), _vm._v(" "), _c('b-table', {
    attrs: {
      "items": _vm.requests,
      "fields": _vm.requestsfields,
      "striped": "",
      "hover": ""
    },
    scopedSlots: _vm._u([{
      key: "icon",
      fn: function(item) {
        return _c('span', {}, [_c('span', {
          staticClass: "glyphicon glyphicon-file"
        })])
      }
    }, {
      key: "reqType",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "name",
      fn: function(item) {
        return _c('span', {}, [(item.item.workflow) ? _c('span', [_vm._v(_vm._s(item.item.workflow.get('name')))]) : _vm._e()])
      }
    }, {
      key: "currentStep",
      fn: function(item) {
        return [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()]
      }
    }, {
      key: "status",
      fn: function(item) {
        return _c('request-status', {
          attrs: {
            "status": item.value
          }
        })
      }
    }, {
      key: "owner",
      fn: function(item) {
        return _c('span', {}, [(item.value) ? _c('span', [_vm._v(_vm._s(item.value.get('name')))]) : _vm._e()])
      }
    }, {
      key: "options",
      fn: function(item) {
        return _c('router-link', {
          staticClass: "btn btn-primary btn-xs",
          attrs: {
            "to": {
              name: 'RequestDetail',
              params: {
                id: item.item.objectId
              }
            }
          }
        }, [_c('span', {
          staticClass: "glyphicon glyphicon-search"
        }), _vm._v(" Ver\n          ")])
      }
    }])
  }), _vm._v(" "), _c('b-pagination', {
    attrs: {
      "size": "sm",
      "total-rows": _vm.count,
      "per-page": _vm.perPage
    },
    on: {
      "input": _vm.getList
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f25acf70"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RequestList.vue
// module id = 1425
// module chunks = 1